import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export function ServiceCustomer() {
  this.getCustomers = () => new Promise((resolve, reject) => {
    axios.get('customer/getCustomerAll')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getCustomersById = id => new Promise((resolve, reject) => {
    axios.get(`customer/getCustomerById/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getCustomersByUuId = () => new Promise((resolve, reject) => {
    axios.get('customer/info')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.addCustomers = data => new Promise((resolve, reject) => {
    axios.post('customer/createCustomer', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(resp => {
        resolve(resp)
      })
      .catch(error => {
        reject(error)
      })
  })

  this.updateCustomers = data => new Promise((resolve, reject) => {
    axios.put('customer/updateCustomer', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(resp => {
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.deleteCustomers = id => new Promise((resolve, reject) => {
    axios.delete(`customer/deleteCustomer/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getSpecialistsSchedules = (id, params) => new Promise((resolve, reject) => {
    axios.get(`customer/specialists/${id}/schedules`, { params })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(error => {
        reject(error)
      })
  })

  this.getFavoritesCustomerById = id => new Promise((resolve, reject) => {
    axios.get(`customer/favorites/${id}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(error => {
        reject(error)
      })
  })

  this.changeFavoritesCustomer = (id, data) => new Promise((resolve, reject) => {
    axios.put(`customer/favorites/${id}/change`, data)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(error => {
        reject(error)
      })
  })

  this.patientAreaCustomer = () => new Promise((resolve, reject) => {
    axios.get('customer/patient-area')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(error => {
        reject(error)
      })
  })

  /* Chat */

  this.contacts = async query => new Promise((resolve, reject) => {
    axios.get('customer/contacts', { params: query })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.getChatMessages = async chatId => new Promise((resolve, reject) => {
    axios.get(`customer/chats/${chatId}/messages`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.markMessagesAsRead = async (chatId, userId) => new Promise((resolve, reject) => {
    axios.put(`customer/chats/${chatId}/is_read`, { userId })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.sendMessage = async (chatId, message) => new Promise((resolve, reject) => {
    axios.post(`customer/chats/${chatId}/messages`, message)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })

  this.handleFileUpload = async (chatId, formData) => new Promise((resolve, reject) => {

    axios.post(`customer/chat/${chatId}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
